import { Tooltip } from "antd";
import { FormattedMessage } from "react-intl";
import type { LabelValue } from "~types/labelValue";

type Props = {
  value: LabelValue[] | null;
  scopeType: string | null;
};

const PermissionScopeValue = ({ value, scopeType }: Props) => {
  if (!scopeType) {
    return <FormattedMessage id="all" />;
  }

  if (!value) {
    return <span>—</span>;
  }

  const valueStr = value.map(({ label }) => label).join(", ");

  return (
    <Tooltip placement="topLeft" title={valueStr}>
      {valueStr}
    </Tooltip>
  );
};

export default PermissionScopeValue;
